import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import useUser from '@shared/utils/hooks/useUser';
import { useQuery } from '@tanstack/react-query';

import { client } from '../utils/trpc';

// The pool only funds bot cost, so the tag fee and award gives must come from
// the user's balance; the pool covers only the bot cost the balance can't.
export const useTronAffordability = ({
  tagEditFee,
  botCost,
  awardCost = 0
}: {
  tagEditFee: number;
  botCost: number;
  awardCost?: number;
}) => {
  const { currentUser } = useUser();
  const total = tagEditFee + botCost + awardCost;
  // Balance-funded portion (tag fee + awards); the pool can only help with bots.
  const balanceFunded = tagEditFee + awardCost;

  const { data: poolStatus } = useQuery({
    queryKey: ['poolStatus'],
    queryFn: () => unwrapFromResult(client.pool.status.query()),
    enabled: total > 0,
    refetchOnWindowFocus: false
  });

  const poolDrawable = poolStatus?.myAccess
    ? Math.min(
        poolStatus.myRemaining4h,
        poolStatus.poolRemaining4h,
        poolStatus.balance
      )
    : 0;
  const balanceForBot = Math.max(0, currentUser.tronsBalance - balanceFunded);
  const botPoolNeeded = Math.max(0, botCost - balanceForBot);

  const insufficientTrons =
    total > 0 &&
    (currentUser.tronsBalance < balanceFunded || botPoolNeeded > poolDrawable);
  const poolCoversRemainder = !insufficientTrons && botPoolNeeded > 0;

  return { insufficientTrons, poolCoversRemainder };
};
